const SCRIPT_URL = "https://checkout.safehavenmfb.com/assets/checkout.min.js";

export function loadSafeHavenCheckout() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Safe Haven Checkout requires a browser"));
  }
  if (window.SafeHavenCheckout) return Promise.resolve(window.SafeHavenCheckout);

  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${SCRIPT_URL}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.SafeHavenCheckout));
      existing.addEventListener("error", () => reject(new Error("Failed to load Safe Haven Checkout")));
      return;
    }
    const script = document.createElement("script");
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve(window.SafeHavenCheckout);
    script.onerror = () => reject(new Error("Failed to load Safe Haven Checkout"));
    document.head.appendChild(script);
  });
}

/**
 * Opens Safe Haven Checkout.js. Resolves with { referenceCode } on success.
 */
export async function openSafeHavenCheckout({
  checkoutConfig,
  referenceCode,
  onClose,
}) {
  const SafeHavenCheckout = await loadSafeHavenCheckout();
  if (!checkoutConfig?.clientId) throw new Error("Bank checkout is not configured");

  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (fn, value) => {
      if (settled) return;
      settled = true;
      fn(value);
    };

    try {
      const payload = {
        environment: checkoutConfig.environment,
        clientId: checkoutConfig.clientId,
        referenceCode: checkoutConfig.referenceCode,
        customer: checkoutConfig.customer,
        currency: checkoutConfig.currency,
        amount: checkoutConfig.amount,
        settlementAccount: checkoutConfig.settlementAccount,
        ...(checkoutConfig.redirectUrl ? { redirectUrl: checkoutConfig.redirectUrl } : {}),
      };

      SafeHavenCheckout({
        ...payload,
        callback: () => finish(resolve, { referenceCode: referenceCode || checkoutConfig.referenceCode }),
        onClose: () => {
          onClose?.();
          finish(reject, new Error("Payment cancelled"));
        },
      });
    } catch (err) {
      finish(reject, err instanceof Error ? err : new Error("Could not open bank checkout"));
    }
  });
}
